<template>
    <section class="feedback section-inside section">
        <div class="container">
            <h2 class="title" v-if="!success">Выезжаем на БЕСПЛАТНЫЙ замер проектов</h2>
            <p class="h3" v-if="!success">c образцами тканей по городу и за его пределами.</p>
            <p class="h3 form__success" v-if="success">
                <img class="form__success-img" src="/assets/img/other/snail.png" alt="">
                <span class="form__success-text">
                        Заявка успешно отправлена! Мы свяжемся с Вами в ближайшее время.
                    </span>
            </p>
            <form class="form" v-if="!success" @submit.prevent="formSubmit">
                <input-text v-model="feedback.name"
                            :v="$v.feedback.name"
                            placeholder="Ваше имя"
                            errorText="Укажите имя"/>
                <input-phone v-model="feedback.phone"
                             :v="$v.feedback.phone"
                             errorText="Укажите корректный номер"
                             placeholder="Телефон"/>
                <div class="input">
                    <v-select :options="cities"
                              :multiple="false"
                              :searchable="false"
                              v-model="feedback.city"
                              @change="$v.feedback.city.$touch()"
                              @blur="$v.feedback.city.$touch()"
                              required
                              placeholder="Укажите область">
                    </v-select>
                    <span class="input__error" v-if="$v.feedback.city.$error">Укажите область</span>
                </div>
                <custom-checkbox
                    :v="$v.feedback.politics"
                    v-model="feedback.politics"
                    :class="{_error: $v.feedback.politics.$error}"
                    checkboxName="politicsFeedback"
                    checkboxText="Отправляя форму, Вы даёте согласие на обработку персональных данных"/>
                <button class="btn" type="submit">Записаться</button>
            </form>
        </div>
    </section>
</template>

<script>
import inputPhone from "../common/inputPhone";
import inputText from "../common/inputText";
import customCheckbox from "../common/custom-checkbox";
import {required, minLength, maxLength, sameAs} from "vuelidate/lib/validators";

export default {
    name: 'promo-form',
    components: {inputText, inputPhone, customCheckbox},
    data() {
        return {
            feedback: {
                phone: null,
                name: null,
                city: null,
                recaptcha: null,
                url: null,
                type: 'callback',
                politics: true
            },
            success: false,
            cities: this.$store.state.cities
        }
    },
    validations: {
        feedback: {
            name: {
                required,
                minLength: minLength(2)
            },
            city: {required},
            politics: {
                sameAs: sameAs( () => true )
            },
            phone: {
                required,
                minLength: minLength(18),
                maxLength: maxLength(18),
                correctAddress(phone) {
                    return /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/.test(phone)
                }
            }
        }
    },
    methods: {
        formSubmit() {
            this.$v.feedback.$touch();
            if (this.$v.feedback.$pending || this.$v.feedback.$error) {
            } else {
                this.recaptcha().then(token => {
                    this.feedback.recaptcha = token;
                    this.feedback.url = window.location.href;
                    this.$http.post('/api/forms/callback', this.feedback).then(res => {})
                    this.success = true;
                    ym(1980352,'reachGoal','promoOrder');
                });
            }
        }
    },
}
</script>
